/** Funnel mock — attendance mode. */

export const FUNNEL_MOCK_ATTENDANCE = {
  mode: 'attendance',
  dataSourceLabel: 'VM Platform · CMP · POS',
  confidence: {
    tone: 'warning',
    title: 'Limited confidence — scan/POS identity not fully linked. 2,100 pending held out.',
  },
  kpis: [
    {
      id: 'conversion',
      label: 'Attendance conversion',
      value: '86.4%',
      detail: '8,900 of 10,300 eligible',
    },
    {
      id: 'dropoff',
      label: 'Biggest drop-off',
      value: 'Scan → POS',
      detail: '−5,800 · 65% of attendees',
    },
    {
      id: 'pending',
      label: 'Pending tickets',
      value: '2,100',
      detail: '3 fixtures · excluded',
    },
    {
      id: 'online_share',
      label: 'Online share',
      value: '38% · +3 pt',
      detail: 'vs 62% on-site',
    },
  ],
  chart: {
    title: 'Attendance conversion',
    stages: [
      {
        id: 'ticket_purchased',
        index: '01',
        label: 'Ticket purchased',
        total: 12400,
        converted: 10300,
        dropped: 0,
        pending: 2100,
        conversionLabel: null,
        droppedLabel: null,
        pendingLabel: '2,100 pending',
      },
      {
        id: 'scanned_in',
        index: '02',
        label: 'Scanned in',
        total: 10300,
        converted: 8900,
        dropped: 1400,
        pending: 0,
        conversionLabel: '86.4%',
        droppedLabel: '−1,400 no-show',
        pendingLabel: null,
      },
      {
        id: 'spent_pos',
        index: '03',
        label: 'Spent at POS',
        subtitle: 'optional',
        total: 8900,
        converted: 3100,
        dropped: 5800,
        pending: 0,
        conversionLabel: '34.8%',
        droppedLabel: '−5,800 no spend',
        pendingLabel: null,
      },
    ],
  },
  pending: {
    total: 2100,
    fixtures: [
      { id: 'gog', label: 'AaB – GOG · 14 Aug', count: 980 },
      { id: 'skjern', label: 'AaB – Skjern · 21 Aug', count: 720 },
      { id: 'bjerringbro', label: 'AaB – BSV · 28 Aug', count: 400 },
    ],
  },
  insight: {
    eyebrow: 'Biggest weak point',
    title: '2 of 3 attendees buy nothing inside the arena.',
    action: 'Trial 2 extra mobile POS units on the next 3 midweek home games.',
  },
  stageInsights: {
    ticket_purchased: {
      eyebrow: 'Baseline',
      title: '12,400 tickets sold · 2,100 still pending fixtures.',
      action: 'Pending is held out — focus on played fixtures only.',
    },
    scanned_in: {
      eyebrow: 'No-shows',
      title: '1,400 eligible buyers never scanned in.',
      action: 'Send a morning-of reminder on the next midweek fixture.',
    },
    spent_pos: {
      eyebrow: 'Biggest weak point',
      title: '2 of 3 attendees buy nothing inside the arena.',
      action: 'Trial 2 extra mobile POS units on the next 3 midweek home games.',
    },
  },
  steps: [
    {
      id: 'ticket_purchased',
      step: '01 Ticket purchased',
      entered: '12,400',
      converted: '10,300 eligible',
      dropOff: '—',
      medianTime: '—',
    },
    {
      id: 'scanned_in',
      step: '02 Scanned in',
      entered: '10,300',
      converted: '8,900 (86.4%)',
      dropOff: '1,400',
      medianTime: '11 days after purchase',
    },
    {
      id: 'spent_pos',
      step: '03 Spent at POS',
      entered: '8,900',
      converted: '3,100 (34.8%)',
      dropOff: '5,800',
      medianTime: '22 min after scan',
    },
    {
      id: 'pending',
      step: 'Pending — not yet played',
      entered: '2,100',
      converted: 'held',
      dropOff: 'not counted',
      medianTime: 'next fixture 14 Aug',
      isPending: true,
    },
  ],
};
